/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Pagination info in wallet response
 * @export
 * @interface WalletPagination
 */
export interface WalletPagination {
    /**
     * 
     * @type {number}
     * @memberof WalletPagination
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof WalletPagination
     */
    limit?: number;
    /**
     * 
     * @type {number}
     * @memberof WalletPagination
     */
    offset?: number;
}

/**
 * Check if a given object implements the WalletPagination interface.
 */
export function instanceOfWalletPagination(value: object): value is WalletPagination {
    return true;
}

export function WalletPaginationFromJSON(json: any): WalletPagination {
    return WalletPaginationFromJSONTyped(json, false);
}

export function WalletPaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): WalletPagination {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'] == null ? undefined : json['total'],
        'limit': json['limit'] == null ? undefined : json['limit'],
        'offset': json['offset'] == null ? undefined : json['offset'],
    };
}

export function WalletPaginationToJSON(json: any): WalletPagination {
    return WalletPaginationToJSONTyped(json, false);
}

export function WalletPaginationToJSONTyped(value?: WalletPagination | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total': value['total'],
        'limit': value['limit'],
        'offset': value['offset'],
    };
}

